module.exports = __webpack_public_path__ + "static/36-THE-FUTURE-OF-WORK-IS-ABOUT-ONE-THING-FLEXIBILITY-4c33d412c6a9b187f3555c35a0fd3c3e.jpg";